import axios from 'axios';
import { baseApi, token } from '../../services/Apis';

export const tiposNivelCodeApi = `${baseApi}/code-levels`;

export const getAllTiposNivelCodeService = async (params) => {
  const res = await axios.get(tiposNivelCodeApi, {
    headers: await token({}),
    params,
  });
  return res;
};

export const saveTiposNivelCodeService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.put(`${tiposNivelCodeApi}/${id}`, data, {
      headers: await token({}),
    });
  } else {
    res = await axios.post(`${tiposNivelCodeApi}`, data, {
      headers: await token({}),
    });
  }
  return res.data;
};

export const getOneTiposNivelCodeService = async (id) => {
  const res = await axios.get(`${tiposNivelCodeApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};

export const deleteTiposNivelCodeService = async (id) => {
  const res = await axios.delete(`${tiposNivelCodeApi}/${id}`, {
    headers: await token({}),
  });
  return res.data;
};
